(()=>{
const root=document.querySelector('[data-taste-profile-results]');if(!root)return;
const testUrl=root.dataset.testUrl||'/pages/taste-profile';
const resultsUrl=root.dataset.resultsUrl||location.pathname;
const $=s=>root.querySelector(s);
function clamp(n){return Math.max(0,Math.min(100,Number(n)||0))}
const decode=s=>window.TasteProfileCodecV132.decode(s);
const encode=o=>window.TasteProfileCodecV132.encode(o);
const params=new URLSearchParams(location.search);
let p=decode(params.get('p')||'');
if(!p){try{p=JSON.parse(sessionStorage.getItem('taste_profile_last_v120')||'null')||JSON.parse(sessionStorage.getItem('taste_profile_last_v132')||'null')||JSON.parse(sessionStorage.getItem('taste_profile_last_v120')||'null')||JSON.parse(sessionStorage.getItem('taste_profile_last_v110')||'null')||JSON.parse(sessionStorage.getItem('taste_profile_last_v100')||'null')}catch(e){}}
if(!p){location.href=testUrl;return}
const other=decode(params.get('c')||params.get('compare')||'');
const names={explorer:'The Explorer',tastemaker:'The Tastemaker',purist:'The Purist',classic:'The Classic'};
p.name=p.name||names[p.key]||'Your profile';
['adv','heat','intensity','acid','texture','sweet'].forEach(k=>p[k]=clamp(p[k]));

function uniqueResultUrl(){
  const u=new URL(resultsUrl,location.origin);
  u.searchParams.set('p',encode(p));
  return u.toString();
}
{
  const u=new URL(resultsUrl,location.origin);
  u.searchParams.set('p',encode(p));
  if(other)u.searchParams.set('c',encode(other));
  if(location.pathname!==u.pathname || params.get('p')!==u.searchParams.get('p') || params.get('compare') || params.get('c')!==u.searchParams.get('c')){
    history.replaceState(null,'',u.toString());
  }
}

window.TasteProfileResultV132=p;
window.dispatchEvent(new CustomEvent('taste_profile:ready',{detail:{profile:p}}));

$('[data-persona]').textContent=p.name;
$('[data-tagline]').textContent=p.tagline||'';
$('[data-copy]').textContent=p.copy||'';
$('[data-chip]').textContent=p.name.replace('The ','');
const vals={adv:p.adv,heat:p.heat,intensity:p.intensity,acid:p.acid,texture:p.texture,sweet:p.sweet};
Object.entries(vals).forEach(([k,v])=>{
  const line=root.querySelector(`[data-line="${k}"]`);
  if(line){line.style.width=`${v}%`;line.parentElement.nextElementSibling.textContent=v}
  const ring=root.querySelector(`[data-ring="${k}"]`);
  if(ring){ring.style.strokeDashoffset=301.6*(1-v/100);const num=ring.closest('.tp-ring').querySelector('strong');if(num)num.textContent=v}
});
const radarPoints=o=>{
  // The polygon lives inside <g transform="translate(160 160)">,
  // so points must be relative to that translated origin.
  const arr=[o.adv,o.heat,o.acid,o.texture,o.sweet,o.intensity],R=112;
  return arr.map((v,i)=>{
    const a=(-90+i*60)*Math.PI/180;
    const r=R*v/100;
    return `${Math.cos(a)*r},${Math.sin(a)*r}`;
  }).join(' ')
};
const poly=$('[data-radar-poly]');if(poly)poly.setAttribute('points',radarPoints(p));

const cuisineByType={
explorer:[['THAILAND','Thai',96,'Heat, acid, aromatics and sweet-savoury tension.'],['CHINA','Sichuan',94,'Chilli, numbing spice, fermentation and bold texture.'],['MEXICO','Oaxacan',91,'Smoke, chilli, acidity and layered sauces.'],['ETHIOPIA','Ethiopian',88,'Fermentation, spice blends and shared dishes.']],
tastemaker:[['JAPAN','Japanese',95,'Precision, clean flavours and carefully controlled texture.'],['FRANCE','Modern French',92,'Detail, technique and balanced richness.'],['DENMARK','Nordic',89,'Ingredient clarity, acidity and restrained complexity.'],['SPAIN','Basque',87,'Strong technique with enough surprise to stay interesting.']],
purist:[['JAPAN','Japanese',94,'Clean ingredients and deliberate restraint.'],['ITALY','Northern Italian',91,'Simple combinations where ingredient quality carries the dish.'],['FRANCE','Classic French',88,'Measured seasoning and controlled texture.'],['GREECE','Greek',84,'Fresh, direct flavours with little need for disguise.']],
classic:[['ITALY','Italian',94,'Familiar structures, generous flavour and dependable pleasure.'],['BRITAIN','British',91,'Comfort, roast flavours and straightforward satisfaction.'],['USA','American',88,'Big comfort formats and familiar reward.'],['FRANCE','Bistro French',85,'Classic dishes with richness and reliable structure.']]
};
const cuisines=cuisineByType[p.key]||cuisineByType.explorer;
$('[data-cuisines]').innerHTML=cuisines.map((c,i)=>`<div class="tp-cuisine"><div class="tp-cuisine__num">0${i+1}</div><div class="tp-cuisine__country">${c[0]}</div><div><h3>${c[1]}</h3><p>${c[3]}</p></div><div class="tp-cuisine__match">${c[2]}%</div></div>`).join('');

function compare(a,b){
  const keys=['adv','heat','intensity','acid','texture','sweet'];
  const diffs=keys.map(k=>Math.abs(clamp(a[k])-clamp(b[k])));
  const avg=diffs.reduce((x,y)=>x+y,0)/diffs.length;
  return Math.max(40,Math.round(100-avg*.85))
}
if(other){
  $('[data-compare-section]').hidden=false;
  const score=compare(p,other);
  $('[data-match-score]').textContent=`${score}%`;
  $('[data-other-name]').textContent=(other.name||names[other.key]||'Other profile').toUpperCase();
  ['adv','heat','intensity','acid','texture','sweet'].forEach(k=>{
    root.querySelector(`[data-left="${k}"]`).style.width=`${clamp(p[k])}%`;
    root.querySelector(`[data-right="${k}"]`).style.width=`${clamp(other[k])}%`
  });
  $('[data-match-headline]').textContent=score>=88?'You two should probably book dinner.':score>=74?'Different palates. Still a very workable table.':'This table may need a little negotiation.';
  $('[data-match-copy]').textContent=score>=88?'Your profiles overlap strongly on the traits that tend to shape restaurant choice. The differences are useful rather than deal-breaking.':score>=74?'There is enough common ground to share a menu, with a few obvious areas where one of you may want to dial things up or down.':'You like food in noticeably different ways. That can still work — but the restaurant choice matters more.'
}

function inviteUrl(){
  const url=new URL(testUrl,location.origin);
  url.searchParams.set('c',encode(p));
  return url.toString()
}
function status(msg){const el=$('[data-copy-status]');if(el){el.textContent=msg;setTimeout(()=>{if(el.textContent===msg)el.textContent=''},3500)}}

function drawCard(canvas){
  const ctx=canvas.getContext('2d'),W=1080,H=1350;
  canvas.width=W;canvas.height=H;
  ctx.fillStyle='#FFFFFF';ctx.fillRect(0,0,W,H);
  ctx.strokeStyle='#E7E8EC';ctx.lineWidth=2;ctx.strokeRect(42,42,W-84,H-84);
  ctx.fillStyle='#5F6066';ctx.font='700 24px Helvetica, Arial';ctx.fillText('TASTE PROFILE',86,112);
  ctx.fillStyle='#171719';ctx.font='800 112px Helvetica, Arial';ctx.fillText('You’re',86,290);
  ctx.fillStyle='#E8343F';ctx.fillText(`${p.name}.`,86,410);
  ctx.fillStyle='#2B2C31';ctx.font='600 42px Helvetica, Arial';
  wrapText(ctx,p.tagline||'',86,520,850,55);
  const data=[['Adventure',p.adv],['Heat',p.heat],['Acid',p.acid],['Sweet',p.sweet]];
  const y0=875,barW=190;
  data.forEach((d,i)=>{
    const x=86+i*235;
    ctx.fillStyle='#171719';ctx.font='800 46px Helvetica, Arial';ctx.fillText(String(d[1]),x,y0);
    ctx.fillStyle='#85868C';ctx.font='700 17px Helvetica, Arial';ctx.fillText(d[0].toUpperCase(),x,y0+42);
    ctx.fillStyle='#ECECF0';roundRect(ctx,x,y0+72,barW,10,5);ctx.fill();
    ctx.fillStyle='#E8343F';roundRect(ctx,x,y0+72,barW*(d[1]/100),10,5);ctx.fill()
  });
  ctx.fillStyle='#85868C';ctx.font='500 21px Helvetica, Arial';ctx.fillText('Take the Taste Profile Test and compare yours.',86,1235)
}
function roundRect(ctx,x,y,w,h,r){const rr=Math.min(r,w/2,h/2);ctx.beginPath();ctx.moveTo(x+rr,y);ctx.arcTo(x+w,y,x+w,y+h,rr);ctx.arcTo(x+w,y+h,x,y+h,rr);ctx.arcTo(x,y+h,x,y,rr);ctx.arcTo(x,y,x+w,y,rr);ctx.closePath()}
function wrapText(ctx,text,x,y,maxWidth,lineHeight){const words=String(text).split(' ');let line='';for(let n=0;n<words.length;n++){const t=line+words[n]+' ';if(ctx.measureText(t).width>maxWidth&&n>0){ctx.fillText(line,x,y);line=words[n]+' ';y+=lineHeight}else line=t}ctx.fillText(line,x,y)}
function cardBlob(){
  return new Promise(resolve=>{
    const c=document.createElement('canvas');drawCard(c);
    c.toBlob(blob=>resolve(blob),'image/png',0.96)
  })
}
async function downloadCard(){
  const blob=await cardBlob();if(!blob)return;
  const a=document.createElement('a');a.href=URL.createObjectURL(blob);
  a.download=`taste-profile-${String(p.key||'result').replace(/[^a-z0-9-]/gi,'-')}.png`;
  document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(a.href),1200);
  status('Result card saved.')
}
async function shareResult(){
  const url=uniqueResultUrl();
  const text=`My Taste Profile: ${p.name}. ${p.tagline||''}`;
  try{
    if(navigator.share){
      await navigator.share({
        title:`Taste Profile — ${p.name}`,
        text,
        url
      });
      return;
    }
    await navigator.clipboard.writeText(`${text}\n${url}`);
    status('Unique result link copied.');
  }catch(e){
    try{
      await navigator.clipboard.writeText(url);
      status('Unique result link copied.');
    }catch(err){
      status(url);
    }
  }
}

$('[data-share-btn]').addEventListener('click',shareResult);

$('[data-compare-btn]').addEventListener('click',async()=>{
  const url=inviteUrl();
  try{
    if(navigator.share){
      await navigator.share({
        title:'Compare our Taste Profiles',
        text:'Take the Taste Profile Test and see how our palates compare.',
        url
      });
      return;
    }
    await navigator.clipboard.writeText(url);
    status('Comparison invite copied.');
  }catch(e){
    try{
      await navigator.clipboard.writeText(url);
      status('Comparison invite copied.');
    }catch(err){
      status(url);
    }
  }
});

const pdfBtn=$('[data-pdf-btn]');
if(pdfBtn)pdfBtn.addEventListener('click',()=>{
  if(!window.TasteProfilePDFV132){status('PDF generator is still loading. Try again in a second.');return}
  const placesData=window.TasteProfilePlacesV132?.getPdfData?.()||{title:'Where we would send you',picks:[]};
  const compareData=other?{
    score:compare(p,other),
    headline:$('[data-match-headline]')?.textContent||'Table Chemistry',
    copy:$('[data-match-copy]')?.textContent||'',
    other,
    otherName:other.name||names[other.key]||'Other profile'
  }:null;
  window.TasteProfilePDFV132.download({
    profile:p,
    cuisines,
    places:placesData.picks||[],
    placeTitle:placesData.title||'Where we would send you',
    compare:compareData,
    url:uniqueResultUrl()
  },`taste-profile-${String(p.key||'result').replace(/[^a-z0-9-]/gi,'-')}-full-results.pdf`);
  status('Full PDF created.');
});
})();